import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "M12.386 6.205a4.8 4.8 0 0 1 1.625.295q.796.284 1.432.932.636.642 1.011 1.721t.375 2.67q.006 1.5-.318 2.683-.318 1.176-.914 1.988a4.04 4.04 0 0 1-1.438 1.239q-.84.426-1.892.426-1.102 0-1.954-.432a3.7 3.7 0 0 1-1.37-1.181 3.76 3.76 0 0 1-.642-1.716h2.074q.159.694.648 1.102.495.403 1.244.403 1.21 0 1.864-1.05.653-1.053.653-2.921h-.08a3 3 0 0 1-.721.863q-.443.359-1.006.551a3.6 3.6 0 0 1-1.181.194 3.5 3.5 0 0 1-1.841-.489 3.57 3.57 0 0 1-1.29-1.341q-.473-.852-.477-1.949 0-1.135.522-2.04a3.8 3.8 0 0 1 1.472-1.431q.944-.53 2.204-.517m.006 1.704q-.613 0-1.108.301a2.14 2.14 0 0 0-.773.807 2.3 2.3 0 0 0-.278 1.13q.005.62.278 1.126.279.506.756.8.483.296 1.102.296a2.1 2.1 0 0 0 1.552-.665q.3-.318.465-.721.171-.404.165-.852 0-.596-.284-1.103a2.2 2.2 0 0 0-.767-.812 2 2 0 0 0-1.108-.307"
    }, null, -1)
  ])))
}
export default { render: render }